<template>
	<div>
		<van-popup v-model="showClause" round class="clause_popup">
			<van-row type="flex" justify="center">
				<span class="text-title">《{{$store.state.systemConfig['register_service_clause.title']}}》</span>
			</van-row>
			<van-row style="height: 75vh;overflow-y: scroll">
				<pre>{{$store.state.systemConfig['register_service_clause.content']}}</pre>
			</van-row>
			<van-row type="flex" justify="center">
				<span class="text-btn" @click="showClause = false">关闭</span>
			</van-row>
		</van-popup>

		<van-form>
			<van-field v-model="phone" required label="手机号" clearable placeholder="请输入手机号" />
			<van-field v-model="verification_code" center clearable label="短信验证码" placeholder="请输入短信验证码" v-if="isNeedVerificationcode">
				<template #button>
					<van-button size="small" type="primary" @click="sendSms" :disabled="!!send_interval">{{send_interval ? send_interval + 's后重试' : '发送验证码'}}</van-button>
				</template>
			</van-field>
			<van-row type="flex" justify="center" v-if="$store.state.systemConfig['register_service_clause.is_enable']" style="margin: 1rem 0;">
				<van-col>
					<van-checkbox v-model="isAgreed" label-disabled>
						我已阅读并同意<span class="link" @click="showClause = true">《{{$store.state.systemConfig['register_service_clause.title']}}》</span>
					</van-checkbox>
				</van-col>
			</van-row>
			<van-button type="primary" block style="margin-top: 20px;" @click="login" :loading="isLoading" :disabled="isDisabled">{{isLoading ? '正在登录中..' : '登录'}}</van-button>
		</van-form>
	</div>
</template>

<script>
    import api from "../../assets/js/api";
    import auth from "../../assets/js/auth";

    export default {
        name: "SmsLogin",
        data(){
            return {
                phone : '',
                verification_code : '',
                send_interval : null,
                isLoading : false,
				isAgreed: false,
				showClause: false
            };
        },
        computed : {
            isNeedVerificationcode() {
                return this.$store.state.systemConfig['wechat.is_sms_login_verification_code']
            },
            isDisabled() {
				return this.$store.state.systemConfig['register_service_clause.is_enable'] ? this.isLoading || !this.isAgreed : this.isLoading
            },
        },
        methods : {
            sendSms(){
                let self = this;
                api.request('/common/send_sms_verification_code', {
                    'phone' : this.phone,
                    'type' : 'login',
                }).then(res => {
                    self.send_interval = res.data.send_interval;
                    let setSmsTimer = setInterval(function () {
                        self.send_interval--;
                        if(self.send_interval <= 0){
                            clearInterval(setSmsTimer);
                            self.send_interval = null;
                        }
                    }, 1000);
                    self.$toast(res.msg);
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
            login(){
                let self = this;
                self.isLoading = true;
                api.request('/user/sms_login', {
                    phone : this.phone,
                    verification_code : this.verification_code,
                    invite_user_id : this.$route.query.invite_user_id,
                }).finally(() => {
                    self.isLoading = false;
                }).then(res => {
                    self.$toast(res.msg);
                    auth.setAuthInfo(res.data);
                    self.$store.commit('syncUserInfo');  //同步用户信息

                    // 没有绑定跳到自动绑定微信
                    if(!self.$store.state.userInfo.is_bind_wechat){
                        let companyId = self.$route.params.companyId;
                        let redirectUrl = self.$route.query.callback_url ? self.$route.query.callback_url : window.location.origin + `/${companyId}/user/index`;
                        redirectUrl = encodeURIComponent(redirectUrl);
                        
                        let param = ''
                        if (!(/^[0-9]+.?[0-9]*$/.test(companyId))) {
                            param = `global_company_wechat_id=${companyId}`
                        } else {
                            param = `global_company_id=${companyId}`
                        }
                        window.location = `${api.REQUEST_URL_PREFIX}/user/bind_wechat?${param}&callback_url=${redirectUrl}&api_token=${auth.getAuthInfo().api_token}`;
                        return;//todo
                    }

                    if(self.$route.query.callback_url)
                        window.location = self.$route.query.callback_url;
                    else
                        self.$router.push({ name : 'User' });
                }).catch(res => {
                    self.$toast(res.msg);
                });
            },
        },
    }
</script>

<style scoped lang="scss">
	.link {
		color: #1989fa;
	}

	.clause_popup {
		width: 70vw;
		padding: 20px;
		font-size: 12px;
		color: #333;
	}

	.text-btn {
		margin-top: 10px;
		color: #1989fa;
		font-size: 14px;
	}

	.text-title {
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
		margin-bottom: 15px;
		font-size: 16px;
		color: #333;
	}
</style>



// WEBPACK FOOTER //
// src/pages/user/SmsLogin.vue